export enum ButtonActionOptions {
  Product = 'product_cta',
  Sticky = 'sticky_cta',
  Template = 'template_cta',
  Upload = 'upload_click',
  UploadSample = 'upload_sample_click',
  Edit = 'edit_click',
  Info = 'info_click',
  SimilarTools = 'similar_tools_click',
  HowTo = 'how_to_section_click',
  ChooseLayout = 'choose_layout',
}
